var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B92AAB9E-5085-4D6F-8C82-455B5DF67649") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.539999962
  }, /*#__PURE__*/React.createElement("g", {
    id: "dealer-central-Dashboard",
    transform: "translate(-1068.000000, -1022.000000)",
    stroke: "#000000",
    fillRule: "nonzero",
    strokeWidth: 0.2,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 1004.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(1068.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55813953,5 C2.2553693,5 2,5.25536744 2,5.55813953 L2,14.8604707 C2,15.1632428 2.2553693,15.4186102 2.55813953,15.4186102 L17.4418605,15.4186102 C17.7446307,15.4186102 18,15.1632428 18,14.8604707 L18,5.55813953 C18,5.25536744 17.7446307,5 17.4418605,5 L2.55813953,5 Z M2.74418605,5.74418605 L17.255814,5.74418605 L17.255814,5.93603721 L10,11.5988521 L2.74418605,5.93603721 L2.74418605,5.74418605 Z M2.74418605,6.87209674 L9.77325581,12.3604707 C9.90696033,12.4632139 10.0930397,12.4632139 10.2267442,12.3604707 L17.255814,6.87209674 L17.255814,14.6744242 L2.74418605,14.6744242 L2.74418605,6.87209674 L2.74418605,6.87209674 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c139ce26fcd28c1559f9db13c8f8d330.svg";
export { ForwardRef as ReactComponent };